import { ChangeEvent, forwardRef } from "react";
import "./index.scss";
import cn from "classnames";

interface IInput {
  label?: string;
  placeholder?: string;
  maxlength?: number;
  error?: any;
  value?: string;
  name: string;
  hint?: string;
  likePopup?: boolean;
  required?: boolean;
  readonly?: boolean;
  type?: "text" | "password";
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Input = forwardRef<HTMLInputElement, IInput>(
  (
    {
      type = "text",
      label = "",
      placeholder = "",
      maxlength= 256,
      error = "",
      value,
      name,
      hint,
      likePopup,
      required,
      readonly,
      onChange = () => {},
      onBlur = () => {},
    },
    ref
  ) => {
    return (
      <div
        className={cn("input", {
          input_popup: !!likePopup,
          input_required: !!required,
          readonly,
        })}
      >
        <div className="input__container">
          {label && <label className="input__label">{label}</label>}
          <div className="input__content">
            <input
              ref={ref}
              type={type}
              className="typo-body"
              placeholder={placeholder}
              maxLength={maxlength}
              {...(readonly
                ? { value }
                : { defaultValue: value, onChange, onBlur })}
              autoComplete={"dsbld"}
              name={name}
            />
            {hint && <span className="input__hint">{hint}</span>}
            {error && <span className="input__error">{error}</span>}
          </div>
        </div>
      </div>
    );
  }
);
export default Input;
